module.exports = __webpack_public_path__ + "img/bp.800d9e12.png";